const DKK_RATE_FROM_EUR = 1;
const DKK_SYMBOL = 'kr.';

export const formatPrice = (price: number): string => {
  const convertedPrice = price * DKK_RATE_FROM_EUR;
  return `${convertedPrice.toFixed(2)} ${DKK_SYMBOL}`;
};
